// Only what Bootstrap cannot do: no `min-height: 0` utility ships (styling guide §1), so the
// flex floor lives here while the column and the fill ride utilities in the component.
// COUPLING: the height tracks the sidebar's visible height, set for the full page in
// libs/webui/page/src/CollapsibleSidebar/CollapsibleSidebar.module.scss and for the flyout in
// libs/webui/util/src/RouteOffCanvas/RouteOffCanvas.module.scss.
// The tab bar takes its own height off the top of that box; the active pane gets the rest and is a column
// flex container, so the thread fills it below the bar exactly as it filled the box before.
.detailTabs {
  min-height: 0;
  min-width: 0;
  height: var(--collapsible-sidebar-visible-height);

  > :global(.tab-content) {
    flex: 1 1 0;
    min-height: 0;

    // `display: flex` stays here: a `d-flex` utility is `!important` and would show the inactive pane.
    > :global(.tab-pane.active) {
      display: flex;
    }
  }
}

.detailThread {
  min-height: 0;
  min-width: 0;
}

.composerSplitter {
  cursor: ns-resize;

  &:focus-visible {
    outline: 2px solid var(--bs-link-color);
    outline-offset: 2px;
  }
}

.composerSplitterPill {
  width: 2.25rem;
  height: 0.3rem;
  background-color: var(--bs-secondary-color);
}

.composerHidden {
  height: 0;
}

// A two-class scope (the always-present editor-header ancestor + this local class) outranks
// the skin reset's `width: auto` — no need to double the same class for specificity. One
// width for the filled Send, Add note and both busy labels, so a mode or busy switch never
// moves the toolbar slot's edge.
:global(.tox-editor-header) .composerSendButton {
  width: 8rem;
}
